import { memo, useMemo, useCallback, useEffect, useState, createRef } from 'react';
import { View, StyleSheet, Text, Image, ScrollView } from 'react-native';
import { I18n, Utils, FormInput, AddButton, Panel, TextInputPlain } from '../../components';
import { THEME, __WEB__, COLOR, FONT } from '../../../constants/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getCurrentEmployer } from '../../../selectors/entities';
import {
  saveEmployerSetupData,
  deleteEmployerSetupData,
  resetStatus,
} from '../../employer/actions';

import EditableList from './editable_list';

export default memo(
  connect(
    function (state, ownProps) {
      const employer = getCurrentEmployer(state);
      const setupData = state.screens.employer.setupData;
      return {
        employer,
        squadrons: setupData?.groups?.slice()?.sort(function (a, b) {
          return a.name < b.name ? -1 : 1;
        }),
      };
    },
    function (dispatch) {
      return {
        actions: bindActionCreators(
          { saveEmployerSetupData, deleteEmployerSetupData, resetStatus },
          dispatch
        ),
      };
    }
  )(function (props) {
    function handleSave(names) {
      props.actions.saveEmployerSetupData(props.employer.employerId, 'groups', { names });
    }
    function doDelete(val) {
      props.actions.deleteEmployerSetupData(
        props.employer.employerId,
        'groups',
        val.employer_group_id
      );
    }
    function handleDelete(val) {
      const confirmationOpts = {
        title: 'Delete this item?',
        confirm: 'Yes, Delete',
        onConfirmed: () => {
          doDelete(val);
        },
      };
      props.onConfirmationOpts(confirmationOpts);
    }
    function handleAddPress() {
      props.actions.resetStatus();
    }
    function itemKey(item) {
      return item.employer_group_id;
    }
    return (
      <EditableList
        panelStyle={{ height: 360 }}
        title="Squadron"
        items={props.squadrons}
        keyFunc={itemKey}
        collapsable={props.collapsable}
        containerStyle={props.containerStyle}
        onSave={handleSave}
        onDelete={handleDelete}
        onAddPress={handleAddPress}
        canEdit={props.canEdit}
        placeholderText="Ex: 959 Security Forces, 959 Aircraft Maint Sq, 75 Aerospace Medicine, ..."
      />
    );
  })
);
